var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotoCityscape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_30804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3328 29.1235H2.65313C1.68047 29.1235 0.890625 28.3336 0.890625 27.361V2.68126C0.890625 1.70861 1.68047 0.918762 2.65313 0.918762H27.3328C28.3055 0.918762 29.0953 1.70861 29.0953 2.68126V27.361C29.0977 28.3336 28.3078 29.1235 27.3328 29.1235Z",
    fill: "url(#paint0_radial_82_30804)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4301 14.6227H23.977V19.7461H14.1074V4.41565H6.71524V19.7461H5.66524V11.5149H2.89258V21.511H5.11914V27.4735H27.884V24.8696H28.4301V14.6227Z",
    fill: "#88BABC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5957 5.88983H8.15117V7.66874H7.5957V5.88983ZM8.7793 5.88983H9.3582V7.66874H8.7793V5.88983ZM10.6098 5.88983H10.0426V7.66874L10.5957 7.66405L10.6098 5.88983Z",
    fill: "#3F737B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8215 5.88983L11.2121 5.89218L11.2285 7.66874H11.8168L11.8215 5.88983ZM7.5957 5.88983H8.15117V7.66874H7.5957V5.88983ZM8.7793 5.88983H9.3582V7.66874H8.7793V5.88983ZM10.6191 5.88983H10.0426V7.66874L10.6121 7.66405L10.6191 5.88983ZM11.8215 8.70233L11.2121 8.70468L11.2285 10.4812H11.8168L11.8215 8.70233ZM7.5957 8.70233H8.15117V10.4812H7.5957V8.70233ZM8.7793 8.70233H9.3582V10.4812H8.7793V8.70233ZM10.6191 8.70233H10.0426V10.4812L10.6121 10.4766L10.6191 8.70233ZM7.5957 11.5148H8.15117V13.2937H7.5957V11.5148ZM8.7793 11.5148H9.3582V13.2937H8.7793V11.5148ZM10.6191 11.5148H10.0426V13.2937L10.6121 13.2891L10.6191 11.5148ZM12.5059 5.88983L12.5035 7.66874H13.1035V5.88983H12.5059ZM24.7379 19.0312H25.4129V19.9547H24.7379V19.0312ZM26.0856 19.0312H26.7606V19.9547H26.0856V19.0312ZM24.7379 17.3039H25.4129V18.2273H24.7379V17.3039ZM26.0856 17.3039H26.7606V18.2273H26.0856V17.3039ZM24.7379 15.6633H25.4129V16.5867H24.7379V15.6633ZM26.0856 15.6633H26.7606V16.5867H26.0856V15.6633Z",
    fill: "#ABD7DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9531 11.5781C26.8688 11.7492 26.9531 21.5859 26.9531 21.5859H23.2336V15.9609H22.036V14.1633H20.9742V12.6375H19.0617V14.2406H17.8453V15.9211H16.5891V24.1125H15.4078V14.9718H15.9586V13.2281H15.4078V9.61638H14.7867L13.9406 7.00075H12.2742L11.4375 9.61638H10.7836V13.2281H10.2024V14.9718H10.7836V24.1125H9.10079V15.8976H4.02891V6.67263C4.02891 6.67263 0.9 6.65154 0.890625 6.66091V27.3609C0.890625 28.3336 1.68047 29.1234 2.65313 29.1234H27.3328C28.3055 29.1234 29.0953 28.3336 29.0953 27.3609V11.5781H26.9531Z",
    fill: "url(#paint1_radial_82_30804)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33789 27.2367H8.36212V27.7875H1.33789V27.2367ZM1.33789 25.2797H8.36212V25.8304H1.33789V25.2797Z",
    fill: "#88BABC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33789 23.2524H8.36212V23.8032H1.33789V23.2524Z",
    fill: "#ABD7DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33789 21.2953H8.36212V21.8461H1.33789V21.2953ZM1.33789 19.0336H8.36212V19.5843H1.33789V19.0336ZM1.33789 17.0765H8.36212V17.6273H1.33789V17.0765Z",
    fill: "#DCEDF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33789 14.8406H1.75039V15.7078H1.33789V14.8406ZM2.74414 14.8406H3.15664V15.7078H2.74414V14.8406Z",
    fill: "#88BABC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33789 13.0992H1.75039V13.9664H1.33789V13.0992ZM2.74414 13.0992H3.15664V13.9664H2.74414V13.0992Z",
    fill: "#ABD7DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33789 11.3578H1.75039V12.225H1.33789V11.3578ZM2.74414 11.3578H3.15664V12.225H2.74414V11.3578ZM1.33789 9.61643H1.75039V10.4836H1.33789V9.61643ZM2.74414 9.61643H3.15664V10.4836H2.74414V9.61643ZM1.33789 7.87268H1.75039V8.73987H1.33789V7.87268ZM2.74414 7.87268H3.15664V8.73987H2.74414V7.87268ZM11.6715 15.1196H12.2035V16.2352H11.6715V15.1196ZM12.9324 15.1196H13.4645V16.2352H12.9324V15.1196ZM14.1465 15.1196H14.6785V16.2352H14.1465V15.1196ZM11.6715 17.2289H12.2035V18.3446H11.6715V17.2289Z",
    fill: "#DCEDF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6719 22.8984H12.2039V24.0141H11.6719V22.8984ZM12.9328 22.8984H13.4648V24.0141H12.9328V22.8984ZM14.1469 22.8984H14.6789V24.0141H14.1469V22.8984Z",
    fill: "#88BABC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9326 17.2289H13.4646V18.3445H12.9326V17.2289ZM14.1467 17.2289H14.6787V18.3445H14.1467V17.2289Z",
    fill: "#DCEDF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6719 19.3383H12.2039V20.4539H11.6719V19.3383ZM12.9328 19.3383H13.4648V20.4539H12.9328V19.3383ZM14.1469 19.3383H14.6789V20.4539H14.1469V19.3383Z",
    fill: "#ABD7DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6588 12.6469H13.751V11.025C13.751 11.025 13.7908 10.4156 13.2002 10.4015C12.6447 10.3875 12.6377 11.0109 12.6377 11.0109C12.6377 11.0109 12.6729 12.6469 12.6588 12.6469ZM18.715 15.0375H19.2471V17.3086H18.715V15.0375ZM20.7096 15.0375H21.2416V17.3086H20.7096V15.0375ZM19.7229 15.0375H20.2549V17.3086H19.7229V15.0375ZM17.8994 18.1828H18.4314V18.907H17.8994V18.1828ZM19.7322 18.1828H20.2643V18.907H19.7322V18.1828ZM21.565 18.1828H22.0971V18.907H21.565V18.1828ZM17.8994 20.5265H18.4314V21.2508H17.8994V20.5265ZM19.7322 20.5265H20.2643V21.2508H19.7322V20.5265ZM21.565 20.5265H22.0971V21.2508H21.565V20.5265Z",
    fill: "#DCEDF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8994 22.7414H18.4314V23.4656H17.8994V22.7414ZM19.7322 22.7414H20.2643V23.4656H19.7322V22.7414ZM21.565 22.7414H22.0971V23.4656H21.565V22.7414Z",
    fill: "#ABD7DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8994 25.0851H18.4314V25.8094H17.8994V25.0851ZM19.7322 25.0851H20.2643V25.8094H19.7322V25.0851ZM21.565 25.0851H22.0971V25.8094H21.565V25.0851ZM17.8994 27.3047H18.4314V28.0289H17.8994V27.3047ZM19.7322 27.3047H20.2643V28.0289H19.7322V27.3047ZM21.565 27.3047H22.0971V28.0289H21.565V27.3047Z",
    fill: "#88BABC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_82_30804",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.4648 23.0742) scale(23.0461 23.0461)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#AFE4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#84D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#67C9F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_82_30804",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.2761 2.66083) scale(29.2664 29.2664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.558,
    stopColor: "#488187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "#477D83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#427078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#3B5B66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#395561"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_30804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotoCityscape);
export default __webpack_public_path__ + "static/media/noto_cityscape.d98251a439d8893c74345d31be6e3a97.svg";
export { ForwardRef as ReactComponent };